import { useEffect, useState } from "react"
import { Helmet } from "react-helmet"
import MasterGamesList from "../data/MasterGamesList"
import { useGlobalContext } from "../data/GlobalContext"
import LoginToPlay from "../data/LoginToPlay"

export const currentPath = window.location.pathname
export const currentDomain = window.location.origin

function LiveGamesPage() {
  const { tokenUrl, launchUrl, username } = useGlobalContext()
  const [afb, setAFB] = useState(false)
  const [login, setLogin] = useState(false)

  // Set AFB visibility based on domain
  // useEffect(() => {
  //   const host = window.location.hostname
  //   if (host === "fgh.fun") {
  //     setAFB(false)
  //   } else if (host === "new.fgh.fun") {
  //     setAFB(true)
  //   } else {
  //     setAFB(false)
  //   }
  // }, [])

  const allLivegames = [
    // {
    //   id: 5,
    //   image: "/images/live-casino-afb-selection.webp",
    //   text: "AFB",
    //   subtxt: "Leading in Asia",
    //   gameID: "74001",
    // },
    // {
    //   id: 6,
    //   image: "/images/live-casino-playtech.webp",
    //   text: "Playtech",
    //   subtxt: "Leading in Asia",
    //   gameID: "96901",
    // },
    {
      id: 1,
      image: "/images/live-casino-evolution-selection.webp",
      text: "Evolution Games",
      subtxt: "Leading in Asia",
      gameID: "25000",
    },
    {
      id: 2,
      image: "/images/live-casino-pp-selection.webp",
      text: "Pragmatic Play",
      subtxt: "Leading in Asia",
      gameID: "84100",
    },
    {
      id: 3,
      image: "/images/live-casino-sa-selection.webp",
      text: "SA Gaming",
      subtxt: "No.1 in Asia",
      gameID: "36001",
    },
    {
      id: 4,
      image: "/images/live-casino-ae-selection.webp",
      text: "AE Casino",
      subtxt: "Leading in Asia",
      gameID: "46001",
    },
  ]

  const livegamesSelection = afb
    ? allLivegames
    : allLivegames.filter((item) => item.text)

  const launchGameInternal = async (gameId) => {
    if (!username) {
      setLogin(true)
      return
    }

    const newWindow = window.open(
      "",
      "gameWindow",
      "width=1024,height=768,toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes"
    )
    if (!newWindow) {
      alert("Popup blocked. Please allow popups and try again.")
      return
    }

    try {
      const requestUrl = `${tokenUrl}?u=${username}&g=${gameId}&t=transfer&m=mobile`
      const response = await fetch(requestUrl)
      if (!response.ok) {
        newWindow.close()
        alert("Failed to fetch game token. Please try again.")
        return
      }
      const data = await response.json()
      const sessionToken = data?.token
      if (!sessionToken) {
        newWindow.close()
        alert("Token not received. Please try again.")
        return
      }
      const lang = "en"
      const isMobile = window.innerWidth <= 768
      const mobileIndicator = isMobile ? "1" : ""

      // const currentPageUrl = `${window.location.origin}${location.pathname}${location.search}${location.hash}`
      // const encodedCurrentPageUrl = encodeURIComponent(currentPageUrl)
      // const launchURL = `${launchUrl}?s=${sessionToken}&l=${lang}&m=${mobileIndicator}&h=${encodedCurrentPageUrl}`

      const launchURL = `${launchUrl}?s=${sessionToken}&l=${lang}&m=${mobileIndicator}`

      newWindow.location.href = launchURL
    } catch (error) {
      newWindow.close()
      console.error("Error launching game:", error)
      alert("An unexpected error occurred. Please try again.")
    }
  }

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Live Dealer - FGH - Your One-Stop Gaming Site</title>
        <link rel="icon" href="/images/fav.webp" sizes="32x32" />
        <meta
          name="description"
          content="Experience real live dealer blackjack and baccarat in the Philippines. Join FGH for secure play, instant payouts, and local wallet support. Must be 21+ to join."
        />
        <link rel="canonical" href={`${currentDomain}${currentPath}`} />
      </Helmet>

      {login && <LoginToPlay onClose={() => setLogin(false)} />}

      <section className="main-body-content all-page-main-container-min-height main-container-global-adjusted-padding">
        <div className="fgh-live-casino-page-main">
          <h1 className="fgh-h1-style normal-margin-bottom">
            Explore our Live Casino Games
          </h1>
          <label className="fgh-normal-label-style standard-margin-bottom">
            (Evolution, Pragmatic Play, AE Casino & SA Gaming)
          </label>
          <div className="fgh-live-casino-page-selection">
            {livegamesSelection.map((data) => (
              <div key={data.id} className="live-casino-page-selection-items">
                <img src={data.image} />
                <div>
                  <label>{data.text}</label>
                  {data.gameID ? (
                    <button onClick={() => launchGameInternal(data.gameID)}>
                      View Lobby
                    </button>
                  ) : (
                    <p>Game not available.</p>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="fgh-live-games">
          <MasterGamesList
            limit={12}
            tools="on"
            livegames="on"
            headerText="Recommended Live Games for You"
            headerTag="h1"
          />
        </div>
        <div className="fgh-section-margin fgh-section-articles">
          <div className="fgh-main-page-content">
            <h2 className="fgh-h2-style standard-margin-bottom">
              FGH – Best Casino Site, Just for You
            </h2>
            <p className="fgh-paragraph-standard-style">
              Get ready to spin, win, and have a blast! At FGH, we bring you a
              thrilling collection of online slots designed to keep the
              excitement rolling.
            </p>
            <p className="fgh-paragraph-standard-style">
              So, why wait? Dive into the action, explore our wide range of
              slots, and let the reels do the talking.
            </p>
          </div>
        </div>
      </section>
    </>
  )
}

export default LiveGamesPage
